import React from "react";
import { IBannerTooltipBodyProps } from "./BannerTooltipBody.interface";

import "./BannerTooltipBody.scss";

const BannerTooltipBody = (props: IBannerTooltipBodyProps) => {
  const { banner } = props;
  const statusText = banner.status
    ? banner.status.toString().toLowerCase()
    : "";
  const statusClass = `banner-status-${statusText}`;
  return (
    <div className="banner-tooltip-body">
      <div className="banner-details">
        {banner.bannerTitle}/{banner.bannerDescription}
      </div>

      <div className={statusClass}>{banner.status}</div>
    </div>
  );
};

export default BannerTooltipBody;
